import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { UIProvider } from '@qualtrics/ui-react';
import allOtherTranslations from '@qualtrics-translations/qualtricsdesignsystemui/en.json';
import countryTranslations from '@qualtrics-translations/qualtricsdesignsystemuicountries/en.json';
import { App } from './components/App';

import './components/highlight/prism';
import '@qualtrics/base-styles';
import './index.scss';

ReactDOM.render(
    <UIProvider
        config={{
            localizedText: { ...allOtherTranslations, ...countryTranslations },
        }}
    >
        <Router basename={__ROUTER_BASENAME__}>
            <App />
        </Router>
    </UIProvider>,
    document.getElementById('root')
);
